module.exports = __webpack_public_path__ + "img/Supporting-Women-Empowerment-650x340.942c245f.png";